import envValues from '../enviornment';

export const SERVER_URL = `${envValues.REACT_APP_API_ENDPOINT}/auth`;
export const SERVER_BASE_URL = envValues.REACT_APP_API_ENDPOINT;
export const ERROR_MESSAGE = 'Api Fetch Error!';
export const ENCRYPT_SECERET_KEY = 'armia-secret-key@123';
export const REACT_APP_API_POST_USER = `${envValues.REACT_APP_API_ENDPOINT}/user`;
export const REACT_APP_API_FETCH_SUB_ADMINS = `${envValues.REACT_APP_API_ENDPOINT}/sub-admins?`;
/** Default profile image for new sub-admin accounts (must match API SUB_ADMIN_DEFAULT_IMAGE). */
export const SUB_ADMIN_DEFAULT_IMAGE =
  'https://safe-sea-staging.s3.amazonaws.com/uploads/Group.png-1779172222317';

/** MongoDB role _id for panel users with the sub-admin role (override in env on server via SUB_ADMIN_ROLE_ID). */
export const SUB_ADMIN_ROLE_ID = '66a1fcae449aaa4fa7dc1ba0';
export const REACT_APP_API_FETCH_USER = `${envValues.REACT_APP_API_ENDPOINT}/user?`;
export const REACT_APP_API_FETCH_EMPLOYEE = `${envValues.REACT_APP_API_ENDPOINT}/employee?active=true&`;
export const REACT_APP_API_FETCH_ROLE = `${envValues.REACT_APP_API_ENDPOINT}/roles?active=true&`;
export const REACT_APP_API_SKILLS = `${envValues.REACT_APP_API_ENDPOINT}/dummy/selectdata`;
export const REACT_APP_API_ROLES_DROPDOWN = `${envValues.REACT_APP_API_ENDPOINT}/roles/select`;
export const REACT_APP_API_FETCH_MOVIES = `${envValues.REACT_APP_API_ENDPOINT}/movies?active=true&`;
export const REACT_APP_API_FETCH_NOTIFICATIONS = `${envValues.REACT_APP_API_ENDPOINT}/notifications?`;
export const REACT_APP_API_FETCH_APPUSER = `${envValues.REACT_APP_API_ENDPOINT}/admin/appuser?`;
/** App user contact submissions (contacts collection) */
export const REACT_APP_API_LANDING_CONTACTS = `${envValues.REACT_APP_API_ENDPOINT}/admin/contact-messages`;
export const REACT_APP_API_ADMIN_FEEDBACKS = `${envValues.REACT_APP_API_ENDPOINT}/admin/feedbacks`;
export const REACT_APP_API_ADMIN_SEA_ROUTE_REPORTS = `${envValues.REACT_APP_API_ENDPOINT}/admin/sea-route-reports`;
export const REACT_APP_API_ADMIN_ROUTES = `${envValues.REACT_APP_API_ENDPOINT}/admin/routes`;
export const REACT_APP_API_ADMIN_POIS = `${envValues.REACT_APP_API_ENDPOINT}/admin/pois`;
export const REACT_APP_API_ADMIN_BATHYMETRY = `${envValues.REACT_APP_API_ENDPOINT}/admin/bathymetry`;
